import { Link } from 'react-router-dom';
import Logo from './Logo';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Logo />
            <p style={{ marginTop: 16, maxWidth: '32ch' }}>
              Practical software for classrooms — built to give educators and
              students their time back.
            </p>
          </div>

          <div>
            <h4>Products</h4>
            <ul>
              <li><Link to="/products/oneschool-companion">OneSchool Companion</Link></li>
              <li><Link to="/products/voceda">Voceda</Link></li>
              <li><Link to="/products/smstutor">SMS Tutor</Link></li>
              <li><Link to="/products">All products</Link></li>
            </ul>
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; {year} Australia College. All rights reserved.</span>
          <span>
            Site by{' '}
            <a href="https://kilowatts.tech" target="_blank" rel="noopener noreferrer">
              Kilowatts Labs
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
